import { useRef, useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import handshake from '../../assets/handshake-01.svg'
import exchange from '../../assets/exchange-01.svg'
import laptopGirl from '../../assets/laptop girl-01.svg'
import exchangeCredit from '../../assets/exchange credit-01.svg'
import groundGirl from '../../assets/ground girl-01.svg'
import floatingBoy from '../../assets/floating boy2-01.svg'
import grass from '../../assets/grass-29.svg'
import groundBoy from '../../assets/ground boy-01.svg'
import floatingGirl from '../../assets/floating girl 1-01.svg'
import grassBack from '../../assets/objects-13.svg'
import grassFront from '../../assets/objects-14.svg'

import obj01 from '../../assets/objects-01.svg'
import obj02 from '../../assets/objects-02.svg'
import obj03 from '../../assets/objects-03.svg'
import obj04 from '../../assets/objects-04.svg'
import obj05 from '../../assets/objects-05.svg'
import obj06 from '../../assets/objects-06.svg'
import obj07 from '../../assets/objects-07.svg'
import obj08 from '../../assets/objects-08.svg'
import obj09 from '../../assets/objects-09.svg'
import obj10 from '../../assets/objects-10.svg'
import obj11 from '../../assets/objects-11.svg'
import obj12 from '../../assets/objects-12.svg'
import obj14 from '../../assets/objects-14.svg'
import obj15 from '../../assets/objects-15.svg'
import obj16 from '../../assets/objects-16.svg'
import obj17 from '../../assets/objects-17.svg'
import obj18 from '../../assets/objects-18.svg'
import obj19 from '../../assets/objects-19.svg'
import obj20 from '../../assets/objects-20.svg'
import obj21 from '../../assets/objects-21.svg'
import obj22 from '../../assets/objects-22.svg'
import obj23 from '../../assets/objects-23.svg'
import obj24 from '../../assets/objects-24.svg'
import obj25 from '../../assets/objects-25.svg'
import obj26 from '../../assets/objects-26.svg'
import obj27 from '../../assets/objects-27.svg'
import obj28 from '../../assets/objects-28.svg'
import obj29 from '../../assets/objects-29.svg'

gsap.registerPlugin(ScrollTrigger)

const objectSources: Record<number, string> = {
  1: obj01, 2: obj02, 3: obj03, 4: obj04, 5: obj05,
  6: obj06, 7: obj07, 8: obj08, 9: obj09, 10: obj10,
  11: obj11, 12: obj12, 14: obj14, 15: obj15, 16: obj16,
  17: obj17, 18: obj18, 19: obj19, 20: obj20, 21: obj21,
  22: obj22, 23: obj23, 24: obj24, 25: obj25, 26: obj26,
  27: obj27, 28: obj28, 29: obj29,
}
const obj = (n: number) => objectSources[n]

function Card({ title, body }: { title: string, body: string }) {
  return (
    <div className="relative max-w-[90vw] md:max-w-[600px]">
      <div data-card-bg className="absolute inset-0 rounded-[2.5rem] bg-white" />
      <div className="relative p-12 md:p-[50px]">
        <h3 data-card-title className="text-[clamp(32px,4vw,50px)] font-medium leading-[0.8] tracking-[-0.5px] text-black">
          {title}
        </h3>
        <p data-card-body className="mt-6 max-w-[480px] text-[18px] leading-[1.32] tracking-[-0.38px] text-black md:mt-7 md:text-[clamp(15px,1.5vw,24px)]">
          {body}
        </p>
      </div>
    </div>
  )
}

export default function ValueCards() {
  const containerRef = useRef<HTMLDivElement>(null)
  const exchangeRef = useRef<HTMLImageElement>(null)
  const exchangeCreditRef = useRef<HTMLImageElement>(null)
  const laptopGirlRef = useRef<HTMLDivElement>(null)
  const cardTrustRef = useRef<HTMLDivElement>(null)
  const cardPeopleRef = useRef<HTMLDivElement>(null)
  const cardLoveRef = useRef<HTMLDivElement>(null)
  const floatingBoyRef = useRef<HTMLImageElement>(null)
  const floatingGirlRef = useRef<HTMLImageElement>(null)
  const obj17Ref = useRef<HTMLImageElement>(null)
  const obj20Ref = useRef<HTMLImageElement>(null)
  const obj22Ref = useRef<HTMLImageElement>(null)
  const handshakeRef = useRef<HTMLImageElement>(null)
  const obj15Ref = useRef<HTMLImageElement>(null)
  const obj18Ref = useRef<HTMLImageElement>(null)
  const obj21Ref = useRef<HTMLImageElement>(null)
  const obj23Ref = useRef<HTMLImageElement>(null)
  const obj16Ref = useRef<HTMLImageElement>(null)
  const obj02Ref = useRef<HTMLImageElement>(null)
  const obj03Ref = useRef<HTMLImageElement>(null)
  const obj05Ref = useRef<HTMLImageElement>(null)
  const obj06Ref = useRef<HTMLImageElement>(null)
  const obj07Ref = useRef<HTMLImageElement>(null)
  const obj09Ref = useRef<HTMLImageElement>(null)
  const obj10Ref = useRef<HTMLImageElement>(null)
  const obj11Ref = useRef<HTMLImageElement>(null)
  const obj12Ref = useRef<HTMLImageElement>(null)
  const obj01Ref = useRef<HTMLImageElement>(null)
  const obj04Ref = useRef<HTMLImageElement>(null)
  const obj08Ref = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const figureEase = 'back.out(1.2)'
    const figureDuration = 0.9
    const triggers: ScrollTrigger[] = []

    const isMobile = window.matchMedia('(max-width: 767px)').matches

    if (exchangeRef.current) gsap.set(exchangeRef.current, { x: '45vw', y: '-65vw', rotate: 18, opacity: 0 })
    if (exchangeCreditRef.current) gsap.set(exchangeCreditRef.current, { x: '-55vw', y: '25vw', rotate: -10, opacity: 0 })
    if (laptopGirlRef.current) gsap.set(laptopGirlRef.current, { x: '-12vw', y: '30vw', rotate: -6, opacity: 0 })
    if (floatingBoyRef.current) gsap.set(floatingBoyRef.current, { x: 0, y: '50vw', rotate: 8, opacity: 0 })
    if (floatingGirlRef.current) gsap.set(floatingGirlRef.current, { x: '-70vw', y: '-20vw', rotate: -15, opacity: 0 })

    if (isMobile) {
      if (obj17Ref.current) gsap.set(obj17Ref.current, { x: '40vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj20Ref.current) gsap.set(obj20Ref.current, { scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj22Ref.current) gsap.set(obj22Ref.current, { scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (handshakeRef.current) gsap.set(handshakeRef.current, { scale: 0, opacity: 0, rotate: -35, transformOrigin: '50% 50%' })
      if (obj18Ref.current) gsap.set(obj18Ref.current, { scale: 0, opacity: 0, rotate: 75, transformOrigin: '50% 50%' })
      if (obj21Ref.current) gsap.set(obj21Ref.current, { scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj15Ref.current) gsap.set(obj15Ref.current, { x: '-40vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj23Ref.current) gsap.set(obj23Ref.current, { scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj16Ref.current) gsap.set(obj16Ref.current, { x: '40vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj11Ref.current) gsap.set(obj11Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: -15, transformOrigin: '50% 50%' })
      if (obj06Ref.current) gsap.set(obj06Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 45, transformOrigin: '50% 50%' })
      if (obj10Ref.current) gsap.set(obj10Ref.current, { x: '-15vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj07Ref.current) gsap.set(obj07Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: -15, transformOrigin: '50% 50%' })
      if (obj05Ref.current) gsap.set(obj05Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 55, transformOrigin: '50% 50%' })
      if (obj09Ref.current) gsap.set(obj09Ref.current, { x: '-15vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj02Ref.current) gsap.set(obj02Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 10, transformOrigin: '50% 50%' })
      if (obj03Ref.current) gsap.set(obj03Ref.current, { x: '-15vw', scale: 0, opacity: 0, transformOrigin: '50% 50%' })
      if (obj12Ref.current) gsap.set(obj12Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: -5, transformOrigin: '50% 50%' })
      if (obj01Ref.current) gsap.set(obj01Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 13, transformOrigin: '50% 50%' })
      if (obj04Ref.current) gsap.set(obj04Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 15, transformOrigin: '50% 50%' })
      if (obj08Ref.current) gsap.set(obj08Ref.current, { x: '-15vw', scale: 0, opacity: 0, rotate: 5, transformOrigin: '50% 50%' })
    }

    const buildCardTimeline = (
      card: HTMLDivElement,
      figures: Array<{ el: HTMLElement; offset: number }>,
      start: string = 'top bottom',
    ) => {
      const bg = card.querySelector('[data-card-bg]')
      const title = card.querySelector('[data-card-title]')
      const body = card.querySelector('[data-card-body]')

      gsap.set(bg, { scale: 0, transformOrigin: '50% 50%' })
      gsap.set([title, body], { opacity: 0, y: -10 })

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start,
          toggleActions: 'play none none reset',
        },
      })
        .to(bg, { scale: 1, duration: 0.6, ease: 'back.out(1.7)' }, 0)
        .to(title, { opacity: 1, y: 0, duration: 0.4, ease: 'sine.inOut' }, 0.3)
        .to(body, { opacity: 1, y: 0, duration: 0.4, ease: 'sine.inOut' }, 0.35)

      figures.forEach(({ el, offset }) => {
        tl.to(el, { x: 0, y: 0, rotate: 0, opacity: 1, duration: figureDuration, ease: figureEase }, offset)
      })

      if (tl.scrollTrigger) triggers.push(tl.scrollTrigger)
      return tl
    }

    if (cardTrustRef.current) {
      const figs: Array<{ el: HTMLElement; offset: number }> = []
      if (exchangeRef.current) figs.push({ el: exchangeRef.current, offset: 0 })
      if (exchangeCreditRef.current) figs.push({ el: exchangeCreditRef.current, offset: 0.1 })
      buildCardTimeline(cardTrustRef.current, figs)

      if (isMobile) {
        const popEase = 'back.out(1.7)'
        const popTl = gsap.timeline({
          scrollTrigger: {
            trigger: cardTrustRef.current,
            start: 'top bottom+=300',
            toggleActions: 'play none none reset',
          },
        })
        if (obj22Ref.current) popTl.to(obj22Ref.current, { scale: 1, opacity: 1, duration: 0.5, ease: popEase }, 0)
        if (obj20Ref.current) popTl.to(obj20Ref.current, { scale: 1, opacity: 1, duration: 0.5, ease: popEase }, 0.1)
        if (obj17Ref.current) popTl.to(obj17Ref.current, { x: 0, scale: 1, opacity: 1, duration: 0.6, ease: popEase }, 0.15)
        if (popTl.scrollTrigger) triggers.push(popTl.scrollTrigger)
      }
    }

    if (cardPeopleRef.current) {
      const figs: Array<{ el: HTMLElement; offset: number }> = []
      if (laptopGirlRef.current) figs.push({ el: laptopGirlRef.current, offset: 0 })
      buildCardTimeline(cardPeopleRef.current, figs)

      if (isMobile) {
        const popEase = 'back.out(1.7)'
        const popTl = gsap.timeline({
          scrollTrigger: {
            trigger: cardPeopleRef.current,
            start: 'top bottom+=300',
            toggleActions: 'play none none reset',
          },
        })
        if (handshakeRef.current) popTl.to(handshakeRef.current, { scale: 1, opacity: 1, rotate: -35, duration: 0.5, ease: popEase }, 0)
        if (obj21Ref.current) popTl.to(obj21Ref.current, { scale: 1, opacity: 1, duration: 0.5, ease: popEase }, 0.1)
        if (obj18Ref.current) popTl.to(obj18Ref.current, { scale: 1, opacity: 1, rotate: 75, duration: 0.5, ease: popEase }, 0.15)
        if (obj15Ref.current) popTl.to(obj15Ref.current, { x: 0, scale: 1, opacity: 1, duration: 0.6, ease: popEase }, 0.2)
        if (popTl.scrollTrigger) triggers.push(popTl.scrollTrigger)
      }
    }

    if (cardLoveRef.current) {
      const figs: Array<{ el: HTMLElement; offset: number }> = []
      if (!isMobile && floatingGirlRef.current) figs.push({ el: floatingGirlRef.current, offset: 0 })
      if (!isMobile && floatingBoyRef.current) figs.push({ el: floatingBoyRef.current, offset: 0.1 })
      buildCardTimeline(cardLoveRef.current, figs)
    }

    if (isMobile && floatingBoyRef.current && floatingGirlRef.current) {
      const popEase = 'back.out(1.7)'
      const popTl = gsap.timeline({
        scrollTrigger: {
          trigger: floatingBoyRef.current,
          start: 'top bottom+=120',
          toggleActions: 'play none none reset',
        },
      })
      if (obj23Ref.current) popTl.to(obj23Ref.current, { scale: 1, opacity: 1, duration: 0.5, ease: popEase }, 0)
      popTl.to(floatingGirlRef.current, { x: 0, y: 0, rotate: 0, opacity: 1, duration: figureDuration, ease: figureEase }, 0)
      popTl.to(floatingBoyRef.current, { x: 0, y: 0, rotate: 0, opacity: 1, duration: figureDuration, ease: figureEase }, 0)
      if (obj16Ref.current) popTl.to(obj16Ref.current, { x: 0, scale: 1, opacity: 1, duration: 0.6, ease: popEase }, 0.15)
      if (popTl.scrollTrigger) triggers.push(popTl.scrollTrigger)
    }

    if (isMobile) {
      const subtleEase = 'back.out(1.4)'
      const sequential: Array<{ ref: HTMLImageElement | null; rotation: number }> = [
        { ref: obj08Ref.current, rotation: 5 },
        { ref: obj11Ref.current, rotation: -15 },
        { ref: obj10Ref.current, rotation: 0 },
        { ref: obj06Ref.current, rotation: 45 },
        { ref: obj01Ref.current, rotation: 13 },
        { ref: obj07Ref.current, rotation: -15 },
        { ref: obj04Ref.current, rotation: 15 },
        { ref: obj09Ref.current, rotation: 0 },
        { ref: obj05Ref.current, rotation: 55 },
        { ref: obj02Ref.current, rotation: 10 },
        { ref: obj03Ref.current, rotation: 0 },
        { ref: obj12Ref.current, rotation: -5 },
      ]
      sequential.forEach(({ ref, rotation }) => {
        if (!ref) return
        const tween = gsap.to(ref, {
          x: 0,
          scale: 1,
          opacity: 1,
          rotate: rotation,
          duration: 0.5,
          ease: subtleEase,
          scrollTrigger: {
            trigger: ref,
            start: 'top bottom-=40',
            toggleActions: 'play none none reset',
          },
        })
        if (tween.scrollTrigger) triggers.push(tween.scrollTrigger)
      })
    }

    return () => triggers.forEach((t) => t.kill())
  }, [])

  return (
    <div ref={containerRef} className="relative z-[9999] mx-auto min-h-[500vw] px-6 md:min-h-[4000px]">

      {/* ── All SVGs absolutely positioned for inspector adjustment ── */}

      {/* Characters */}
      <img ref={handshakeRef} data-svg="handshake" src={handshake} alt="People shaking hands" className="absolute left-[63vw] top-[90vw] w-[35vw] -rotate-[35deg] md:left-[10vw] md:top-[25vw] md:w-[24vw]" />
      <img ref={exchangeRef} data-svg="exchange" src={exchange} alt="Two people exchanging items" className="absolute right-[-15vw] top-[-10vw] w-[70vw] md:right-[2vw] md:top-[-30vw] md:w-[49vw]" />
      <div ref={laptopGirlRef} className="absolute left-[15vw] top-[130vw] w-[40vw] md:left-[55vw] md:top-[35vw] md:w-[34vw]">
        <img data-svg="laptop-girl" src={laptopGirl} alt="Person designing on a device" className="block w-full" />
      </div>
      <img ref={exchangeCreditRef} data-svg="exchange-credit" src={exchangeCredit} alt="People excitedly exchanging goods" className="absolute left-[-10vw] top-[5vw] w-[70vw] md:left-[-3vw] md:top-[-10vw] md:w-[50vw]" />
      {/* <img data-svg="ground-girl" src={groundGirl} alt="" className="absolute right-[10vw] top-[97vw] w-[8vw]" /> */}
      <img ref={floatingBoyRef} data-svg="floating-boy" src={floatingBoy} alt="" className="absolute left-[40vw] top-[418vw] w-[55vw] md:left-[35vw] md:top-[140vw] md:w-[50vw]" />

      {/*── Objects already placed ─────────────*/}
      <img ref={obj01Ref} data-svg="obj-01" src={obj(1)} alt="" className="absolute left-[46vw] top-[265vw] w-[28vw] rotate-[13deg] md:left-[2vw] md:top-[22vw] md:w-[3vw] md:rotate-0" />
      <img ref={obj04Ref} data-svg="obj-04" src={obj(4)} alt="" className="absolute left-[-11vw] top-[270vw] w-[30vw] rotate-[15deg] md:left-[5vw] md:top-[120vw] md:w-[19vw] md:-rotate-[35deg]" />
      <img ref={obj06Ref} data-svg="obj-06" src={obj(6)} alt="" className="absolute left-[15vw] top-[265vw] w-[30vw] rotate-45 md:left-[60vw] md:top-[93vw] md:w-[15vw]" />
      <img ref={obj08Ref} data-svg="obj-08" src={obj(8)} alt="" className="absolute left-[32vw] top-[245vw] w-[30vw] rotate-[5deg] md:left-[70vw] md:top-[120vw] md:w-[15vw] md:-rotate-[15deg]" />
      <img ref={obj11Ref} data-svg="obj-11" src={obj(11)} alt="" className="absolute left-[1vw] top-[252vw] w-[18vw] -rotate-[15deg] md:left-[5vw] md:top-[111vw] md:w-[3vw] md:rotate-0" />
      {/* <img data-svg="obj-14" src={obj(14)} alt="" className="absolute left-[10vw] top-[50vw] w-[3.3vw]" /> */}
      <img ref={obj16Ref} data-svg="obj-16" src={obj(16)} alt="" className="absolute right-[10vw] top-[396vw] w-[34vw] md:right-[12vw] md:top-[172vw] md:w-[3.2vw]" />
      <img data-svg="obj-19" src={obj(19)} alt="" className="absolute left-[65vw] top-[55vw] w-[22vw] -rotate-[105deg] md:left-[8vw] md:top-[19vw] md:w-[12vw]" />
      <img ref={obj23Ref} data-svg="obj-23" src={obj(23)} alt="" className="absolute left-[7vw] top-[424vw] w-[14vw] md:left-[20vw] md:top-[200vw] md:w-[2.6vw]" />

      {/* Objects — remaining, surfaced at 10vw for placement (move these as needed) */}
      <img ref={obj03Ref} data-svg="obj-03" src={obj(3)} alt="" className="absolute left-[38vw] top-[300vw] z-[11] w-[30vw] md:left-[5vw] md:top-[80vw] md:w-[10vw]" />
      <img ref={obj05Ref} data-svg="obj-05" src={obj(5)} alt="" className="absolute left-[12vw] top-[290vw] z-[11] w-[25vw] rotate-[55deg] md:left-[45vw] md:top-[78vw] md:w-[12vw] md:rotate-0" />
      <img ref={obj07Ref} data-svg="obj-07" src={obj(7)} alt="" className="absolute left-[86vw] top-[265vw] z-[11] w-[30vw] -rotate-[15deg] md:left-[5vw] md:top-[95vw] md:w-[10vw] md:rotate-0" />
      <img ref={obj09Ref} data-svg="obj-09" src={obj(9)} alt="" className="absolute left-[64vw] top-[283vw] z-[11] w-[25vw] md:right-[5vw] md:top-[95vw] md:w-[10vw] md:left-auto" />
      <img ref={obj12Ref} data-svg="obj-12" src={obj(12)} alt="" className="absolute left-[-4vw] top-[308vw] z-[11] w-[21vw] -rotate-[5deg] md:left-[9vw] md:top-[135vw] md:w-[14vw] md:-rotate-[25deg]" />
      <img ref={obj15Ref} data-svg="obj-15" src={obj(15)} alt="" className="absolute left-[9vw] top-[110vw] z-[11] w-[25vw] md:left-[20vw] md:top-[160vw] md:w-[15vw]" />
      <img ref={obj17Ref} data-svg="obj-17" src={obj(17)} alt="" className="absolute left-[41vw] top-[-8vw] z-[11] w-[30vw] md:left-[45vw] md:top-[-25vw] md:w-[15vw]" />
      <img ref={obj18Ref} data-svg="obj-18" src={obj(18)} alt="" className="absolute left-[60vw] top-[130vw] z-[11] w-[28vw] rotate-[75deg] md:left-[44vw] md:top-[32vw] md:w-[15vw]" />
      <img ref={obj21Ref} data-svg="obj-21" src={obj(21)} alt="" className="absolute right-0 top-[119vw] z-[11] w-[18vw] md:right-[25vw] md:top-[155vw] md:w-[10vw]" />
      <img ref={obj22Ref} data-svg="obj-22" src={obj(22)} alt="" className="absolute left-[2vw] top-[-12vw] z-[11] w-[14vw] md:left-[5vw] md:top-[170vw] md:w-[10vw]" />
      <img data-svg="obj-24" src={obj(24)} alt="" className="absolute left-[55vw] top-[160vw] z-[11] w-[20vw] md:left-[35vw] md:top-[40vw] md:w-[10vw]" />
      <img data-svg="obj-26" src={obj(26)} alt="" className="absolute left-[5vw] top-[480vw] z-[11] w-[25vw] md:left-[4vw] md:top-[252vw] md:w-[15vw]" />
      <img data-svg="obj-27" src={obj(27)} alt="" className="absolute left-[69vw] top-[482vw] z-[11] w-[22vw] md:left-[5vw] md:top-[195vw] md:w-[10vw]" />
      <img data-svg="obj-28" src={obj(28)} alt="" className="absolute right-[5vw] top-[415vw] z-[11] w-[25vw] md:right-auto md:left-[84vw] md:top-[-3vw] md:w-[16vw]" />
      <img data-svg="obj-29" src={obj(29)} alt="" className="absolute left-[35vw] top-[285vw] z-[11] w-[25vw] md:left-[72vw] md:top-[107vw] md:w-[15vw]" />



      {/* Camping scene — sits below the cards, part of the same section */}
        <img src={groundBoy} alt="" className="absolute left-0 top-[460vw] z-10 w-[45vw] md:left-[2vw] md:top-[234vw] md:w-[38vw]" />
        <img src={groundGirl} alt="" className="absolute left-[50vw] top-[460vw] z-10 w-[50vw] md:left-[40vw] md:top-[238vw] md:w-[44vw]" />
        <img ref={floatingGirlRef} src={floatingGirl} alt="" className="absolute left-[5vw] top-[388vw] z-10 w-[48vw] md:left-[5vw] md:top-[176vw] md:w-[42vw]" />

        <img src={grass} alt="" className="absolute bottom-0 left-[5vw] w-[12vw] md:w-[6vw]" />
        <img src={grass} alt="" className="absolute bottom-0 right-[8vw] w-[11vw] -scale-x-100 md:w-[5.5vw]" />
        <img src={grass} alt="" className="absolute bottom-0 left-[30vw] w-[8vw] md:w-[4vw]" />
        <img src={grass} alt="" className="absolute bottom-0 right-[25vw] w-[10vw] -scale-x-100 md:w-[5vw]" />

        <img ref={obj02Ref} src={obj(2)} alt="" className="absolute left-[80vw] top-[290vw] w-[30vw] rotate-[10deg] z-[11] md:left-[40vw] md:top-[130vw] md:w-[16vw]" />
        <img ref={obj10Ref} src={obj(10)} alt="" className="absolute right-[10vw] top-[254vw] w-[20vw] z-[11] md:right-[7vw] md:top-[65vw] md:w-[10vw]" />
        <img ref={obj20Ref} src={obj(20)} alt="" className="absolute left-[85vw] top-[-21vw] w-[11vw] z-[11] md:left-[39vw] md:top-[-10vw] md:w-[6vw]" />
        <img src={obj(25)} alt="" className="absolute left-[30vw] top-[475vw] w-[30vw] z-[11] md:left-[20vw] md:top-[252vw] md:w-[19vw]" />

      {/* Grass backgrounds — bottom touches the next (yellow) section */}
      <img src={grassBack} alt="" className="pointer-events-none absolute bottom-0 left-0 z-[1] w-screen select-none rounded-[44px]" />
      <img src={grassFront} alt="" className="pointer-events-none absolute bottom-0 left-0 w-screen select-none rounded-[44px]" />



      {/* Cards (also absolutely positioned for now) */}
      <div ref={cardTrustRef} data-svg="card-trust" className="absolute left-[5vw] top-[40vw] z-[20] md:left-[45vw] md:top-0">
        <Card
          title="Set the standard"
          body="Integrate once with Oak. From there, rich experiences reach every platform your products live on."
        />
      </div>
      <div ref={cardPeopleRef} data-svg="card-people" className="absolute left-[5vw] top-[180vw] z-[20] md:left-[15vw] md:top-[50vw]">
        <Card
          title="Deepen context"
          body="Your IP becomes more intelligent over time — who's talking about it, what's trending, where it's loved."
        />
      </div>
      <div ref={cardLoveRef} data-svg="card-love" className="absolute left-[5vw] top-[320vw] z-[20] md:left-[25vw] md:top-[100vw]">
        <Card
          title="Grow together"
          body="Explore new integrations, see what's working, and partner with other licensors on Oak."
        />
      </div>

    </div>
  )
}
